module.exports = __webpack_public_path__ + "img/eps.8f4cedf9.png";